<div class="header">
    <div class="row">
        <div class="col-6">
            <h2>Modifica <strong>Pratica</strong></h2>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/dashboard']">Pratiche</a></li>
                <li class="active">Modifica Pratica</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-10 portlets" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div *ngIf="request.IDRequest !== undefined" class="session-valid">
                    <div *ngIf="currentStep === 1" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <form #step1Form="ngForm" role="form" class="form-horizontal form-validation">
                                <p class="section-customer-data">Dati relativi alla Pratica</p>
                                <div class="form-group">
                                    <label for="email" class="col-sm-3 control-label">E-mail:</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="email"
                                               name="company-nameemail"
                                               class="form-control"
                                               placeholder="Inserisci e-mail del cliente"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(email.valid || email.pristine),
                                                'form-success': email.valid
                                           }"
                                               [(ngModel)]="request.Email"
                                               #email="ngModel">
                                        <i class="icon-envelope"></i>
                                        <div [hidden]="email.valid || email.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="referrer" class="col-sm-3 control-label">Segnalatore:</label>
                                    <div class="col-sm-9">
                                        <ng-select id="referrer"
                                                   name="referrer"
                                                   [items]="partyOptions"
                                                   bindLabel="label"
                                                   bindValue="key"
                                                   groupBy="group"
                                                   [selectableGroup]="false"
                                                   [multiple]="true"
                                                   [clearable]="true"
                                                   [searchable]="true"
                                                   [closeOnSelect]="false"
                                                   [searchFn]="searchPartyOption"
                                                   appendTo="body"
                                                   placeholder="Seleziona segnalatori o fornitori"
                                                   notFoundText="Nessun segnalatore o fornitore trovato"
                                                   [(ngModel)]="selectedPartyKeys"
                                                   (ngModelChange)="onPartiesChange($event)">
                                            <ng-template ng-label-tmp let-item="item">
                                                <span class="party-kind" [class.party-kind-supplier]="item.kind === 'supplier'">{{ item.kindLabel }}</span>
                                                <span>{{ item.label }}</span>
                                            </ng-template>
                                            <ng-template ng-option-tmp let-item="item">
                                                <span class="party-kind" [class.party-kind-supplier]="item.kind === 'supplier'">{{ item.kindLabel }}</span>
                                                <span>{{ item.label }}</span>
                                                <small *ngIf="item.hint" class="customer-option-hint">{{ item.hint }}</small>
                                            </ng-template>
                                        </ng-select>
                                        <span class="field-hint">Puoi associare nessuno, uno o più segnalatori e fornitori.</span>
                                        <span class="field-hint" *ngIf="partyLoadError">{{ partyLoadError }}</span>
                                    </div>
                                </div>
                                <div *ngIf="request.PaymentDetails !== '' && request.PaymentDetails !== ''" class="form-group">
                                    <label for="payment-details"
                                           class="col-sm-3 control-label">Informazioni Costi:</label>
                                    <div class="col-sm-9 payment-text">
                                        <textarea
                                                id="payment-details"
                                                name="payment-details"
                                                class="form-control"
                                                rows="8"
                                                autocomplete="off"
                                                [(ngModel)]="request.PaymentDetails">
                                        </textarea>
                                    </div>
                                </div>
                                <div *ngIf="(request.PaymentDetails === '' || request.PaymentDetails === '') && request.PaymentCost1 !== 0" class="form-group">
                                    <label for="investment-amount" class="col-sm-3 control-label">
                                        Costi Pratica "Nuova Sabatini"
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="number"
                                               id="payment-cost-1"
                                               name="payment-cost-1"
                                               class="form-control"
                                               placeholder="Inserisci i costi della pratica Nuova Sabatini"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(paymentCost1.valid || paymentCost1.pristine),
                                                'form-success': paymentCost1.valid
                                           }"
                                               [(ngModel)]="request.PaymentCost1"
                                               #paymentCost1="ngModel">
                                        <i class="icon-wallet"></i>
                                        <div [hidden]="paymentCost1.valid || paymentCost1.pristine"
                                             class="form-error valid">
                                            Inserisci i costi.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="(request.PaymentDetails === '' || request.PaymentDetails === '') && request.PaymentCost2 !== 0" class="form-group">
                                    <label for="investment-amount" class="col-sm-3 control-label">
                                        Costi Pratica "Iperammortamento 4.0"
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="number"
                                               id="payment-cost-2"
                                               name="payment-cost-2"
                                               class="form-control"
                                               placeholder="Inserisci i costi della pratica Iperammortamento 4.0"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(paymentCost2.valid || paymentCost2.pristine),
                                                'form-success': paymentCost2.valid
                                           }"
                                               [(ngModel)]="request.PaymentCost2"
                                               #paymentCost2="ngModel">
                                        <i class="icon-wallet"></i>
                                        <div [hidden]="paymentCost2.valid || paymentCost2.pristine"
                                             class="form-error valid">
                                            Inserisci i costi.
                                        </div>
                                    </div>
                                </div>
                                <p class="section-customer-data">Dati relativi alla Società / Ditta Individuale</p>
                                <div class="form-group">
                                    <label for="company-name" class="col-sm-3 control-label">Ragione Sociale
                                        Società / Ditta individuale</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="company-name"
                                               name="company-name"
                                               class="form-control"
                                               placeholder="Inserisci ragione sociale della società / ditta individuale"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(companyName.valid || companyName.pristine),
                                                'form-success': companyName.valid
                                           }"
                                               [(ngModel)]="customer.CompanyName"
                                               #companyName="ngModel">
                                        <i class="icon-drawer"></i>
                                        <div [hidden]="companyName.valid || companyName.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="vat" class="col-sm-3 control-label">Partita IVA</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="vat"
                                               name="vat"
                                               class="form-control"
                                               placeholder="Inserisci partita IVA"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(vat.valid || vat.pristine),
                                                'form-success': vat.valid
                                           }"
                                               [(ngModel)]="customer.VATNumber"
                                               #vat="ngModel">
                                        <i class="icon-list"></i>
                                        <div [hidden]="vat.valid || vat.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="head-office" class="col-sm-3 control-label">Sede Legale Società / Ditta
                                        Individuale (Comune e Provincia)</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="head-office"
                                               name="head-office"
                                               class="form-control"
                                               placeholder="Inserisci comune della sede legale"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(headOffice.valid || headOffice.pristine),
                                                'form-success': headOffice.valid
                                           }"
                                               [(ngModel)]="customer.HeadOffice"
                                               #headOffice="ngModel">
                                        <i class="icon-home"></i>
                                        <div [hidden]="headOffice.valid || headOffice.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="head-office-province"
                                               name="head-office-province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               maxlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(headOfficeProvince.valid || headOfficeProvince.pristine),
                                                'form-success': headOfficeProvince.valid
                                           }"
                                               [(ngModel)]="customer.HeadOfficeProvince"
                                               #headOfficeProvince="ngModel">
                                        <div [hidden]="headOfficeProvince.valid || headOfficeProvince.pristine"
                                             class="form-error valid">
                                            Inserire esattamente 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="address" class="col-sm-3 control-label">Via e Civico Sede Legale</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="address"
                                               name="address"
                                               class="form-control"
                                               placeholder="Inserisci via della sede legale"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(address.valid || address.pristine),
                                                'form-success': address.valid
                                           }"
                                               [(ngModel)]="customer.Address"
                                               #address="ngModel">
                                        <i class="icon-home"></i>
                                        <div [hidden]="address.valid || address.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="house-number"
                                               name="house-number"
                                               class="form-control"
                                               placeholder="Inserisci civico"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(houseNumber.valid || houseNumber.pristine),
                                                'form-success': houseNumber.valid
                                           }"
                                               [(ngModel)]="customer.HouseNumber"
                                               #houseNumber="ngModel">
                                        <div [hidden]="houseNumber.valid || houseNumber.pristine"
                                             class="form-error valid">
                                            Campo richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group">
                                    <label for="iban" class="col-sm-3 control-label">IBAN</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="iban"
                                               name="iban"
                                               class="form-control"
                                               placeholder="Inserisci IBAN (27 caratteri)"
                                               minlength="27"
                                               maxlength="27"
                                               required
                                               autocomplete="off"
                                               (paste)="onPasteIBAN($event)"
                                               [ngClass]="{
                                                'form-error': !(companyName.valid || companyName.pristine),
                                                'form-success': companyName.valid
                                           }"
                                               (ngModelChange)="onChangeIBAN($event)"
                                               [ngModel]="customer.IBAN"
                                               #iban="ngModel">
                                        <i class="icon-credit-card"></i>
                                        <div [hidden]="iban.valid || iban.pristine"
                                             class="form-error valid">
                                            Inserisci esattamente 27 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group">
                                    <label for="support-bank-name" class="col-sm-3 control-label">Nome della Banca di
                                        appoggio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="support-bank-name"
                                               name="support-bank-name"
                                               class="form-control"
                                               placeholder="Inserisci nome della banca di appoggio"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(supportBankName.valid || supportBankName.pristine),
                                                'form-success': supportBankName.valid
                                           }"
                                               [(ngModel)]="customer.SupportBankName"
                                               #supportBankName="ngModel">
                                        <i class="icon-wallet"></i>
                                        <div [hidden]="supportBankName.valid || supportBankName.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group">
                                    <label for="support-bank-bic" class="col-sm-3 control-label">BIC della Banca di
                                        appoggio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="support-bank-bic"
                                               name="support-bank-bic"
                                               class="form-control"
                                               placeholder="Inserisci BIC della banca di appoggio (8 o 11 caratteri)"
                                               minlength="8"
                                               maxlength="11"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(supportBankBIC.valid || supportBankBIC.pristine),
                                                'form-success': supportBankBIC.valid
                                           }"
                                               [(ngModel)]="customer.SupportBankBIC"
                                               #supportBankBIC="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="supportBankBIC.valid || supportBankBIC.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 8 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="sdi-code" class="col-sm-3 control-label">Codice SDI</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="sdi-code"
                                               name="sdi-code"
                                               class="form-control"
                                               placeholder="Inserisci codice SDI (7 caratteri)"
                                               minlength="7"
                                               maxlength="7"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(sdiCode.valid || sdiCode.pristine),
                                                'form-success': sdiCode.valid
                                           }"
                                               [(ngModel)]="customer.SDICode"
                                               #sdiCode="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="sdiCode.valid || sdiCode.pristine"
                                             class="form-error valid">
                                            Inserisci esattamente 7 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="ula-last-balance" class="col-sm-3 control-label">ULA Ultimo
                                        Bilancio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="ula-last-balance"
                                               name="ula-last-balance"
                                               class="form-control"
                                               placeholder="Inserisci ULA relative all'ultimo bilancio approvato"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(ulaLastBalance.valid || ulaLastBalance.pristine),
                                                'form-success': ulaLastBalance.valid
                                           }"
                                               [(ngModel)]="customer.ULALastBalance"
                                               #ulaLastBalance="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Unità lavorative anno, ovvero il numero medio di dipendenti occupati
                                            nell'impresa relativamente all'ultimo Bilancio/Modello Unico depositato.
                                        </div>
                                        <div [hidden]="ulaLastBalance.valid || ulaLastBalance.pristine"
                                             class="form-error valid">
                                            Campo richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="phone" class="col-sm-3 control-label">Numero di Telefono Fisso</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="phone"
                                               name="phone"
                                               class="form-control"
                                               placeholder="Inserisci numero di telefono fisso"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(phone.valid || phone.pristine),
                                                'form-success': phone.valid
                                           }"
                                               [(ngModel)]="customer.Phone"
                                               #phone="ngModel">
                                        <i class="icon-call-end"></i>
                                        <div [hidden]="phone.valid || phone.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="mobile-phone" class="col-sm-3 control-label">Numero di Telefono
                                        Cellulare</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="mobile-phone"
                                               name="mobile-phone"
                                               class="form-control"
                                               placeholder="Inserisci numero di telefono cellulare"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(mobilePhone.valid || mobilePhone.pristine),
                                                'form-success': mobilePhone.valid
                                           }"
                                               [(ngModel)]="customer.MobilePhone"
                                               #mobilePhone="ngModel">
                                        <i class="icon-screen-smartphone"></i>
                                        <div [hidden]="mobilePhone.valid || mobilePhone.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <p class="section-customer-data" style="margin-top: 40px;">Dati del Legale Rappresentante per compilazione del Contratto di Consulenza</p>

                                <div class="form-group">
                                    <label for="name" class="col-sm-3 control-label">Nome Legale Rappresentante</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="name"
                                               name="name"
                                               class="form-control"
                                               placeholder="Inserisci nome del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(name.valid || name.pristine),
                                                'form-success': name.valid
                                           }"
                                               [(ngModel)]="customer.Name"
                                               #name="ngModel">
                                        <i class="icon-user"></i>
                                        <div [hidden]="name.valid || name.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="surname" class="col-sm-3 control-label">Cognome Legale Rappresentante</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="surname"
                                               name="surname"
                                               class="form-control"
                                               placeholder="Inserisci cognome del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(surname.valid || surname.pristine),
                                                'form-success': surname.valid
                                           }"
                                               [(ngModel)]="customer.Surname"
                                               #surname="ngModel">
                                        <i class="icon-user"></i>
                                        <div [hidden]="surname.valid || surname.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="birth-place" class="col-sm-3 control-label">Luogo di Nascita Legale
                                        Rappresentante (Comune e Provincia)</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="birth-place"
                                               name="birth-place"
                                               class="form-control"
                                               placeholder="Inserisci comune del luogo di nascita del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(birthPlace.valid || birthPlace.pristine),
                                                'form-success': birthPlace.valid
                                           }"
                                               [(ngModel)]="customer.BirthPlace"
                                               #birthPlace="ngModel">
                                        <i class="icon-pin"></i>
                                        <div [hidden]="name.valid || name.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="birth-place-province"
                                               name="birth-place-province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(birthPlaceProvince.valid || birthPlaceProvince.pristine),
                                                'form-success': birthPlaceProvince.valid
                                           }"
                                               [(ngModel)]="customer.BirthPlaceProvince"
                                               #birthPlaceProvince="ngModel">
                                        <div [hidden]="birthPlaceProvince.valid || birthPlaceProvince.pristine"
                                             class="form-error valid">
                                            Inserire almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="birth-date" class="col-sm-3 control-label">Data di Nascita Legale Rappresentante</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="birth-date"
                                               name="birth-date"
                                               class="form-control"
                                               placeholder="Inserisci data di nascita del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(birthDate.valid || birthDate.pristine),
                                                'form-success': birthDate.valid
                                           }"
                                               [(ngModel)]="birthDateString"
                                               #birthDate="ngModel">
                                        <i class="icon-calendar"></i>
                                        <div [hidden]="birthDate.valid || birthDate.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="city" class="col-sm-3 control-label">Residenza Legale Rappresentante
                                        (Comune e Provincia)</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="city"
                                               name="city"
                                               class="form-control"
                                               placeholder="Inserisci comune di residenza del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(city.valid || city.pristine),
                                                'form-success': city.valid
                                           }"
                                               [(ngModel)]="customer.City"
                                               #city="ngModel">
                                        <i class="icon-pin"></i>
                                        <div [hidden]="city.valid || city.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="province"
                                               name="province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               maxlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(province.valid || province.pristine),
                                                'form-success': province.valid
                                           }"
                                               [(ngModel)]="customer.Province"
                                               #province="ngModel">
                                        <div [hidden]="province.valid || province.pristine"
                                             class="form-error valid">
                                            Inserire esattamente 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="text-center m-t-40">
                                    <button type="button"
                                            class="btn btn-embossed btn-info"
                                            (click)="goToStep(2)">
                                        <i class="glyphicon glyphicon-arrow-right"></i>Dati Investimento
                                    </button>
                                    <button type="button"
                                            class="btn btn-embossed btn-info"
                                            (click)="goToStep(3)">
                                        <i class="glyphicon glyphicon-arrow-right"></i>Documenti
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div *ngIf="currentStep === 2" class="row" id="step2" style="margin-top: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <form #step2Form="ngForm" role="form"
                                  class="form-horizontal form-validation">
                                <p class="section-customer-data">Dati relativi all'Investimento</p>
                                <div class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La società partecipa e/o è partecipata da altre società per quote pari o
                                        superiori al 25% (società collegata/associata)?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="company-participation"
                                                         name="company-participation"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.CompanyParticipation">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        I soci partecipano, anche di concerto, in altre società?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="partners-participation"
                                                         name="partners-participation"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.PartnersParticipation">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Si è scelto di procedere con l'investimento tramite:
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="investment-mode"
                                                         name="investment-mode"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.InvestmentMode">
                                            <mat-radio-button
                                                    *ngFor="let radioInvestmentModeOption of radioInvestmentModeOptions"
                                                    [value]="radioInvestmentModeOption">
                                                <span style="font-weight: 400 !important;">{{ radioInvestmentModeOption }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="request.InvestmentMode !== 'Fondi Propri'" class="form-group">
                                    <label for="leasing-company-name" class="col-sm-3 control-label">Nome Società di
                                        Leasing Finanziatrice</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="leasing-company-name"
                                               name="leasing-company-name"
                                               class="form-control"
                                               placeholder="Inserisci nome della società di leasing finanziatrice"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(leasingCompanyName.valid || leasingCompanyName.pristine),
                                                'form-success': leasingCompanyName.valid
                                           }"
                                               [(ngModel)]="request.LeasingCompanyName"
                                               #leasingCompanyName="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="leasingCompanyName.valid || leasingCompanyName.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.InvestmentMode !== 'Fondi Propri'" class="form-group m-b-30">
                                    <label class="col-sm-3 control-label">
                                        Durata Leasing / Finanziamento:
                                    </label>
                                    <div class="col-sm-9">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Seleziona durata</mat-label>
                                            <mat-select id="investment-duration"
                                                       name="investment-duration"
                                                       required
                                                       [(ngModel)]="request.InvestmentDuration">
                                                <mat-option *ngFor="let radioInvestmentDurationOption of radioInvestmentDurationOptions"
                                                           [value]="radioInvestmentDurationOption">
                                                    {{ radioInvestmentDurationOption }} anni
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="operational-headquarters" class="col-sm-3 control-label">
                                        Comune Sede Operativa (Unità locale di destinazione beni oggetto dell'investimento):
                                    </label>
                                    <div class="col-sm-7 prepend-icon m-t-10">
                                        <input type="text"
                                               id="operational-headquarters"
                                               name="operational-headquarters"
                                               class="form-control"
                                               placeholder="Inserisci sede operativa"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquarters.valid || operationalHeadquarters.pristine),
                                                'form-success': operationalHeadquarters.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquarters"
                                               #operationalHeadquarters="ngModel">
                                        <i class="icon-home"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Si indichi un’unità operativa che compare nella visura camerale. Se la sede
                                            operativa oggetto dell’investimento coincide con la sede legale, indicare
                                            quest’ultima.
                                        </div>
                                        <div [hidden]="operationalHeadquarters.valid || operationalHeadquarters.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2 m-t-10">
                                        <input type="text"
                                               id="operational-headquarters-province"
                                               name="operational-headquarters-province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               maxlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquartersProvince.valid || operationalHeadquartersProvince.pristine),
                                                'form-success': operationalHeadquartersProvince.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquartersProvince"
                                               #operationalHeadquartersProvince="ngModel">
                                        <div [hidden]="operationalHeadquartersProvince.valid || operationalHeadquartersProvince.pristine"
                                             class="form-error valid">
                                            Inserire esattamente 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="operational-headquarters-address" class="col-sm-3 control-label">Via e Civico Sede Operativa</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="operational-headquarters-address"
                                               name="operational-headquarters-address"
                                               class="form-control"
                                               placeholder="Inserisci via della sede operativa"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquartersAddress.valid || operationalHeadquartersAddress.pristine),
                                                'form-success': operationalHeadquartersAddress.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquartersAddress"
                                               #operationalHeadquartersAddress="ngModel">
                                        <i class="icon-home"></i>
                                        <div [hidden]="operationalHeadquartersAddress.valid || operationalHeadquartersAddress.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="operational-headquarters-house-number"
                                               name="operational-headquarters-house-number"
                                               class="form-control"
                                               placeholder="Civico"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquartersHouseNumber.valid || operationalHeadquartersHouseNumber.pristine),
                                                'form-success': operationalHeadquartersHouseNumber.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquartersHouseNumber"
                                               #operationalHeadquartersHouseNumber="ngModel">
                                        <div [hidden]="operationalHeadquartersHouseNumber.valid || operationalHeadquartersHouseNumber.pristine"
                                             class="form-error valid">
                                            Campo richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label class="col-12">Indicare i dati catastali dell'unità operativa/struttura
                                        produttiva/capannone industriale dove si intende fare l’investimento.</label>
                                    <label for="cadastral-code" class="col-sm-3 control-label">Codice catastale</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="cadastral-code"
                                               name="cadastral-code"
                                               class="form-control"
                                               placeholder="Inserisci il codice catastale"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(cadastralCode.valid || cadastralCode.pristine),
                                                'form-success': cadastralCode.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralCode"
                                               #cadastralCode="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="cadastralCode.valid || cadastralCode.pristine"
                                             class="form-error valid">
                                            Il codice catastale è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-section" class="col-sm-3 control-label">Sezione</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-section"
                                               name="tax-credit-5-section"
                                               class="form-control"
                                               placeholder="Inserisci la sezione dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Section.valid || taxCredit5Section.pristine),
                                                'form-success': taxCredit5Section.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralSection"
                                               #taxCredit5Section="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Se non presente, indicare NP.
                                        </div>
                                        <div [hidden]="taxCredit5Section.valid || taxCredit5Section.pristine"
                                             class="form-error valid">
                                            La sezione dei dati catastali è richiesta.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-sheet" class="col-sm-3 control-label">Foglio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-sheet"
                                               name="tax-credit-5-sheet"
                                               class="form-control"
                                               placeholder="Inserisci il foglio dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Sheet.valid || taxCredit5Sheet.pristine),
                                                'form-success': taxCredit5Sheet.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralSheet"
                                               #taxCredit5Sheet="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Sheet.valid || taxCredit5Sheet.pristine"
                                             class="form-error valid">
                                            Il foglio dei dati catastali è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-particle" class="col-sm-3 control-label">Particella prevalente</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-particle"
                                               name="tax-credit-5-particle"
                                               class="form-control"
                                               placeholder="Inserisci la particella dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Particle.valid || taxCredit5Particle.pristine),
                                                'form-success': taxCredit5Particle.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralParticle"
                                               #taxCredit5Particle="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Particle.valid || taxCredit5Particle.pristine"
                                             class="form-error valid">
                                            La particella prevalente dei dati catastali è richiesta.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-sub" class="col-sm-3 control-label">Sub prevalente</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-sub"
                                               name="tax-credit-5-sub"
                                               class="form-control"
                                               placeholder="Inserisci il dato sub dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Sub.valid || taxCredit5Sub.pristine),
                                                'form-success': taxCredit5Sub.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralSub"
                                               #taxCredit5Sub="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Se non presente, indicare NP.
                                        </div>
                                        <div [hidden]="taxCredit5Sub.valid || taxCredit5Sub.pristine"
                                             class="form-error valid">
                                            Il dato sub prevalente dei dati catastali è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5"
                                     class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Il bene oggetto di agevolazione rientra nella categoria:
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInvestmentTypeValues[0]"
                                                      (change)="valueChangeInvestmentType(0)">
                                            {{ checkboxInvestmentTypeOptions[0] }}
                                        </mat-checkbox>
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInvestmentTypeValues[1]"
                                                      (change)="valueChangeInvestmentType(1)">
                                            {{ checkboxInvestmentTypeOptions[1] }}
                                        </mat-checkbox>
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInvestmentTypeValues[2]"
                                                      (change)="valueChangeInvestmentType(2)">
                                            {{ checkboxInvestmentTypeOptions[2] }}
                                        </mat-checkbox>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="investment-amount" class="col-sm-3 control-label">
                                        Importo totale dell'investimento (al netto dell'IVA)
                                    </label>
                                    <div class="col-sm-9 prepend-icon investment-amount-wrap m-t-10">
                                        <input type="text"
                                               id="investment-amount"
                                               name="investment-amount"
                                               class="form-control"
                                               placeholder="Inserisci l'importo totale dell'investimento"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(investmentAmount.valid || investmentAmount.pristine),
                                                'form-success': investmentAmount.valid
                                           }"
                                               [(ngModel)]="investmentAmountDisplay"
                                               (keydown)="onInvestmentAmountKeyDown($event)"
                                               (input)="onInvestmentAmountInput($event)"
                                               (blur)="onInvestmentAmountBlur()"
                                               #investmentAmount="ngModel">
                                        <i class="icon-wallet"></i>
                                        <span class="euro-prefix" aria-hidden="true">€</span>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Le migliaia sono separate automaticamente; usare punto o virgola per i centesimi (fino a 2 cifre).
                                        </div>
                                        <div [hidden]="investmentAmount.valid || investmentAmount.pristine"
                                             class="form-error valid">
                                            Il campo è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label class="col-sm-3 control-label">
                                        Aliquota di ammortamento
                                    </label>
                                    <div class="col-sm-9 m-t-10">
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox checkbox-multiple-depreciation"
                                                      [ngModel]="multipleDepreciationRates"
                                                      [ngModelOptions]="{ standalone: true }"
                                                      (ngModelChange)="onMultipleDepreciationRatesChange($event)">
                                            Più beni con aliquote di ammortamento diverse
                                        </mat-checkbox>
                                    </div>
                                </div>

                                <div *ngIf="(request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && !multipleDepreciationRates"
                                     class="form-group">
                                    <div class="col-sm-offset-3 col-sm-9 prepend-icon percent-suffix-wrap m-t-10">
                                        <input type="number"
                                               id="depreciation-rate"
                                               placeholder="Inserisci l'aliquota di ammortamento"
                                               class="form-control"
                                               step="any"
                                               min="0"
                                               max="100"
                                               autocomplete="off"
                                               (wheel)="$event.preventDefault()"
                                               [ngModelOptions]="{ standalone: true }"
                                               [ngClass]="{
                                                'form-error': !(depreciationRate.valid || depreciationRate.pristine),
                                                'form-success': depreciationRate.valid
                                           }"
                                               [(ngModel)]="request.DepreciationRate"
                                               #depreciationRate="ngModel">
                                        <i class="icon-wallet"></i>
                                        <span class="percent-suffix">%</span>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Consultare il vostro commercialista/consulente fiscale per individuare l'aliquota di ammortamento del/i bene/beni oggetto di investimento
                                        </div>
                                        <div [hidden]="depreciationRate.valid || depreciationRate.pristine"
                                             class="form-error valid">
                                            Il campo è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="(request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && multipleDepreciationRates"
                                     class="form-group">
                                    <div class="col-sm-offset-3 col-sm-9 m-t-10">
                                        <div class="depreciation-assets-list">
                                            <div *ngFor="let asset of request.DepreciationAssets; let i = index"
                                                 class="depreciation-asset-row">
                                                <input type="text"
                                                       class="form-control depreciation-asset-description"
                                                       placeholder="Descrizione del bene"
                                                       autocomplete="off"
                                                       [ngModelOptions]="{ standalone: true }"
                                                       [(ngModel)]="asset.description">
                                                <div class="depreciation-rate-wrap">
                                                    <input type="number"
                                                           class="form-control depreciation-asset-rate"
                                                           placeholder="Aliquota"
                                                           step="any"
                                                           min="0"
                                                           max="100"
                                                           autocomplete="off"
                                                           (wheel)="$event.preventDefault()"
                                                           [ngModelOptions]="{ standalone: true }"
                                                           [(ngModel)]="asset.rate">
                                                    <span class="percent-suffix">%</span>
                                                </div>
                                                <button *ngIf="request.DepreciationAssets!.length > 2"
                                                        type="button"
                                                        class="depreciation-asset-delete-btn"
                                                        aria-label="Rimuovi bene"
                                                        (click)="removeDepreciationAsset(i)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                            <button type="button"
                                                    class="btn btn-sm btn-default btn-embossed m-t-10"
                                                    (click)="addDepreciationAsset()">
                                                + Aggiungi bene
                                            </button>
                                        </div>
                                        <div class="info-box m-t-10">
                                            <i class="fa fa-info-circle"></i>
                                            Consultare il vostro commercialista/consulente fiscale per individuare l'aliquota di ammortamento del/i bene/beni oggetto di investimento
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="ateco-code" class="col-sm-3 control-label">
                                        L'investimento programmato a quale attività lavorativa si riferisce? (Indicare
                                        il Codice ATECO)
                                    </label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="ateco-code"
                                               name="ateco-code"
                                               class="form-control"
                                               placeholder="Inserisci il codice ATECO"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(atecoCode.valid || atecoCode.pristine),
                                                'form-success': atecoCode.valid
                                           }"
                                               [(ngModel)]="request.AtecoCode"
                                               #atecoCode="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="atecoCode.valid || atecoCode.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-30">
                                    <label *ngIf="request.FKIDRequestType !== 2" class="col-12 control-label">
                                        L'investimento sarà oggetto di altre agevolazioni?
                                    </label>
                                    <label *ngIf="request.FKIDRequestType === 2" class="col-12 control-label">
                                        L'investimento sarà oggetto di altre agevolazioni, oltre al Credito d’imposta
                                        4.0?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="concessions"
                                                         name="concessions"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.Concessions">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="request.Concessions" class="form-group">
                                    <label for="concessions-details" class="col-sm-3 control-label">
                                        Indicare quali (ad esempio Bandi nazionali, regionali, locali, ecc.)
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="text"
                                               id="concessions-details"
                                               name="concessions-details"
                                               class="form-control"
                                               placeholder="Indicare di quali agevolazioni sarà oggetto l'investimento"
                                               minlength="2"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(concessionsDetails.valid || concessionsDetails.pristine),
                                                'form-success': concessionsDetails.valid
                                           }"
                                               [(ngModel)]="request.ConcessionsDetails"
                                               #concessionsDetails="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="concessionsDetails.valid || concessionsDetails.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <!-- Parte 4.0 -->
                                <div *ngIf="checkboxInvestmentTypeValues[1] && (request.FKIDRequestType === 2 || request.FKIDRequestType === 4)" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Il credito d'imposta 4.0, attualmente pari al 20% dell'importo
                                        dell'investimento, si può compensare in 3 anni dalla data di interconnessione
                                        del bene. Decidete di procedere con la compensazione in 3 anni (2025-2026-2027)?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-4-years"
                                                         name="tax-credit-4-years"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit4Years">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="checkboxInvestmentTypeValues[1] && (request.FKIDRequestType === 2 || request.FKIDRequestType === 4) && (request.TaxCredit4Years === false)"
                                     class="form-group">
                                    <label for="support-bank-bic" class="col-sm-3 control-label">Indica gli anni in cui
                                        andrai a compensare il relativo credito d’imposta 4.0</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="number"
                                               id="tax-credit-4-years-compensation"
                                               name="tax-credit-4-years-compensation"
                                               class="form-control"
                                               placeholder="Inserisci gli anni"
                                               min="0"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit4YearsCompensation.valid || taxCredit4YearsCompensation.pristine),
                                                'form-success': taxCredit4YearsCompensation.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit4YearsCompensation"
                                               #taxCredit4YearsCompensation="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit4YearsCompensation.valid || taxCredit4YearsCompensation.pristine"
                                             class="form-error valid">
                                            Inserisci un numero.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="checkboxInvestmentTypeValues[1] && (request.FKIDRequestType === 2 || request.FKIDRequestType === 4)" class="form-group">
                                    <label for="birth-date" class="col-sm-3 control-label">Data presunta di avvio
                                        dell'investimento</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-4-start-date"
                                               name="tax-credit-4-start-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di avvio dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit4StartDate.valid || taxCredit4StartDate.pristine),
                                                'form-success': taxCredit4StartDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit4StartDate"
                                               #taxCredit4StartDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <div *ngIf="checkboxInvestmentTypeValues[1] && (request.FKIDRequestType === 2 || request.FKIDRequestType === 4)" class="form-group">
                                    <label for="birth-date" class="col-sm-3 control-label">Data presunta di conclusione
                                        dell'investimento (data stimata di consegna del bene)</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-4-end-date"
                                               name="tax-credit-4-end-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di conclusione dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit4EndDate.valid || taxCredit4EndDate.pristine),
                                                'form-success': taxCredit4EndDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit4EndDate"
                                               #taxCredit4EndDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <!-- DNS + IP. 4.0 -->
                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La Società/ditta individuale rispetta le normative sulla sicurezza nei luoghi di
                                        lavoro applicabili in ciascun settore e gli obblighi di versamento dei
                                        contributi previdenziali e assistenziali a favore dei lavoratori?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-regulations"
                                                         name="tax-credit-5-regulations"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5Regulations">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La Società/ditta individuale è un'impresa destinataria di sanzioni interdittive
                                        ai sensi del decreto legislativo 8 giugno 2001, n. 231 e ai sensi del codice
                                        antimafia di cui al decreto legislativo 6 settembre 2011, n. 159?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-sanctions"
                                                         name="tax-credit-5-sanctions"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5Sanctions">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group">
                                    <label for="tax-credit-5-beneficial-owner" class="col-sm-3 control-label">Chi è il
                                        Titolare Effettivo?</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-beneficial-owner"
                                               name="tax-credit-5-beneficial-owner"
                                               class="form-control"
                                               placeholder="Inserisci il titolare effettivo"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(beneficialOwner.valid || beneficialOwner.pristine),
                                                'form-success': beneficialOwner.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5BeneficialOwner"
                                               #beneficialOwner="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            In caso di più titolari effettivi, scrivere Nome e Cognome separato da punto
                                            e virgola
                                        </div>
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Secondo la normativa antiriciclaggio per titolari effettivi si intendono le
                                            persone fisiche che, in ultima istanza, possiedono o controllano un’entità
                                            giuridica ovvero ne risultano i beneficiari.
                                        </div>
                                        <div [hidden]="beneficialOwner.valid || beneficialOwner.pristine"
                                             class="form-error valid">
                                            Il titolare effettivo è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La Società ha già un revisore legale dei conti?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-revisor"
                                                         name="tax-credit-5-revisor"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5Revisor">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Indicare se il bilancio della società viene sottoposto a revisione
                                            contabile.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.TaxCredit5Revisor" class="form-group">
                                    <label for="ateco-code" class="col-sm-3 control-label">
                                        Contatto e-mail del revisore legale dei conti
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="email"
                                               id="tax-credit-5-revisor-email"
                                               name="tax-credit-5-revisor-email"
                                               class="form-control"
                                               placeholder="Inserisci il contatto e-mail del revisore legale dei conti"
                                               minlength="2"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(revisorEmail.valid || revisorEmail.pristine),
                                                'form-success': revisorEmail.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5RevisorEmail"
                                               #revisorEmail="ngModel">
                                        <i class="icon-envelope"></i>
                                        <div [hidden]="revisorEmail.valid || revisorEmail.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.TaxCredit5Revisor" class="form-group">
                                    <label for="ateco-code" class="col-sm-3 control-label">
                                        Contatto telefonico del revisore legale dei conti
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="tel"
                                               id="tax-credit-5-revisor-phone"
                                               name="tax-credit-5-revisor-phone"
                                               class="form-control"
                                               placeholder="Inserisci il contatto telefonico del revisore legale dei conti"
                                               minlength="2"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(revisorPhone.valid || revisorPhone.pristine),
                                                'form-success': revisorPhone.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5RevisorPhone"
                                               #revisorPhone="ngModel">
                                        <i class="icon-call-in"></i>
                                        <div [hidden]="revisorPhone.valid || revisorPhone.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Esistono altri progetti di innovazione 5.0 in corso?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-projects"
                                                         name="tax-credit-5-projects"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5OtherProjects">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Viene generata un'elevata dose di sostanze inquinanti classificabili come
                                        rifiuti speciali pericolosi?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-waste"
                                                         name="tax-credit-5-waste"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5SpecialWaste">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La {{ customer.CompanyName }} è proprietaria o affittuaria della struttura
                                        produttiva dove intende fare l’investimento?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-structure-owner"
                                                         name="tax-credit-5-structure-owner"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5StructureOwner">
                                            <mat-radio-button *ngFor="let radioStructureOwnerOption of radioStructureOwnerOptions"
                                                              [value]="radioStructureOwnerOption">
                                                <span style="font-weight: 400 !important;">{{ radioStructureOwnerOption }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Il progetto di innovazione rispetta il principio DNSH?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-dnsh"
                                                         name="tax-credit-5-dnsh"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5DNSH">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group">
                                    <label for="tax-credit-5-start-date" class="col-sm-3 control-label">Data presunta di avvio dell'investimento</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-5-start-date"
                                               name="tax-credit-5-start-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di avvio dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5StartDate.valid || taxCredit5StartDate.pristine),
                                                'form-success': taxCredit5StartDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5StartDate"
                                               #taxCredit5StartDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-end-date" class="col-sm-3 control-label">Data presunta di conclusione dell'investimento (data stimata di consegna del bene)</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-5-end-date"
                                               name="tax-credit-5-end-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di conclusione dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5EndDate.valid || taxCredit5EndDate.pristine),
                                                'form-success': taxCredit5EndDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5EndDate"
                                               #taxCredit5EndDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group">
                                    <label class="col-12">Indicare i dati catastali dell'unità operativa/struttura
                                        produttiva/capannone industriale dove si intende fare l’investimento.</label>
                                    <label for="cadastral-code" class="col-sm-3 control-label">Codice catastale</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="cadastral-code"
                                               name="cadastral-code"
                                               class="form-control"
                                               placeholder="Inserisci il codice catastale"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(cadastralCode.valid || cadastralCode.pristine),
                                                'form-success': cadastralCode.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralCode"
                                               #cadastralCode="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="cadastralCode.valid || cadastralCode.pristine"
                                             class="form-error valid">
                                            Il codice catastale è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        L'investimento sarà completato entro il 31/12/2025?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-year-end"
                                                         name="tax-credit-5-year-end"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5YearEnd">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        L’investimento programmato ha uno scopo di "ampliamento aziendale"?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="business-expansion"
                                                         name="business-expansion"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.BusinessExpansion">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Si ricorda che l’agevolazione non è riconosciuta in caso di
                                            sostituzione/permuta del bene oggetto di investimento.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 5" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        L’investimento programmato ha uno scopo di "ampliamento aziendale" o di
                                        "sostituzione"?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-business-expansion"
                                                         name="tax-credit-5-business-expansion"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5BusinessExpansion">
                                            <mat-radio-button *ngFor="let radioTaxCredit5BusinessExpansion of radioTaxCredit5BusinessExpansionOptions"
                                                              [value]="radioTaxCredit5BusinessExpansion">
                                                <span style="font-weight: 400 !important;">{{ radioTaxCredit5BusinessExpansion }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div class="text-center m-t-40">
                                    <button type="button"
                                            class="btn btn-embossed btn-info"
                                            (click)="goToStep(1)">
                                        <i class="glyphicon glyphicon-arrow-left"></i>Dati Società / Ditta
                                    </button>
                                    <button type="button"
                                            class="btn btn-embossed btn-info"
                                            (click)="goToStep(3)">
                                        <i class="glyphicon glyphicon-arrow-right"></i>Documenti
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div *ngIf="currentStep === 3" class="row" style="margin-top: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <div *ngIf="!request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">Visura Camerale aggiornata</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['1'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="chamber-commerce-certificate"
                                               name="chamber-commerce-certificate"
                                               (change)="uploadDocument($event, 1)"
                                               required>
                                        <label class="custom-file-label"
                                               for="chamber-commerce-certificate">{{ fileName[1] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['1'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['1']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Formato accettato PDF, non ammessa la scannerizzazione del documento.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">Ultimo Bilancio approvato</div>
                                <div class="col-9 input-group">
                                    <div *ngIf="documentList['2'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="last-balance"
                                               name="last-balance"
                                               (change)="uploadDocument($event, 2)"
                                               required>
                                        <label class="custom-file-label"
                                               for="last-balance">{{ fileName[2] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['2'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['2']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Formato accettato PDF/DOCX, non ammessa la scannerizzazione del documento.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType !== 5 && request.FKIDRequestType !== 7" class="row m-b-10">
                                <div class="col-3 m-t-12">Marca da Bollo da 16 euro</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['3'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="revenue-stamp"
                                               name="revenue-stamp"
                                               (change)="uploadDocument($event, 3)"
                                               required>
                                        <label class="custom-file-label"
                                               for="revenue-stamp">{{ fileName[3] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['3'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['3']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        È possibile caricare una scannerizzazione o una foto. La marca da bollo
                                        originale dovrà essere conservata, così da esibirla in caso di controlli.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">Carta di Identità del Titolare della Società/Ditta
                                    Individuale
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="id-card-owner"
                                               name="id-card-owner"
                                               (change)="uploadDocument($event, 4)"
                                               required>
                                        <label class="custom-file-label"
                                               for="id-card-owner">{{ fileName[4] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="request.FKIDRequestType === 5" class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Caricare le carte di identità di tutti i titolari effettivi indicati nella
                                        sezione 3.
                                    </div>
                                    <div class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['4']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 || request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="row m-b-10">
                                <div class="col-3 m-t-12">DURC in corso di validità</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="durc"
                                               name="durc"
                                               (change)="uploadDocument($event, 8)"
                                               required>
                                        <label class="custom-file-label"
                                               for="supplier-offer">{{ fileName[8] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['8'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['8']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="(request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && !request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">DVR</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="dvr"
                                               name="dvr"
                                               (change)="uploadDocument($event, 29)"
                                               required>
                                        <label class="custom-file-label"
                                               for="supplier-offer">{{ fileName[29] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['29'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['29']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 && request.TaxCredit5BusinessExpansion === 'Sostituzione'"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Fatture, DDT, Verbali di consegna</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="fatture"
                                               name="fatture"
                                               (change)="uploadDocument($event, 10)"
                                               required>
                                        <label class="custom-file-label"
                                               for="fatture">{{ fileName[10] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['10'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['10']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        In caso di sostituzione del bene oggetto di investimento con uno nuovo, occorre
                                        caricare copia della fattura di acquisto, DDT e verbale di consegna del bene sostituito”)
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 && request.TaxCredit5BusinessExpansion === 'Sostituzione'"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Libro cespiti da cui si evince la registrazione del bene
                                    oggetto di sostituzione</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="libro-cespiti"
                                               name="libro-cespiti"
                                               (change)="uploadDocument($event, 15)"
                                               required>
                                        <label class="custom-file-label"
                                               for="libro-cespiti">{{ fileName[15] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['15'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['15']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 || ((request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && !request.Simplified)"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Visura catastale della struttura produttiva</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="visura-struttura"
                                               name="visura-struttura"
                                               (change)="uploadDocument($event, 16)"
                                               required>
                                        <label class="custom-file-label"
                                               for="visura-struttura">{{ fileName[16] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['16'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['16']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 && request.TaxCredit5StructureOwner === 'Affittuaria'"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Contratto di affitto della struttura produttiva</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="contratto-affitto-struttura"
                                               name="contratto-affitto-struttura"
                                               (change)="uploadDocument($event, 17)"
                                               required>
                                        <label class="custom-file-label"
                                               for="contratto-affitto-struttura">{{ fileName[17] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['17'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['17']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-b-10">
                                <div class="col-3 m-t-12">Offerta del Fornitore non timbrata</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="supplier-offer"
                                               name="supplier-offer"
                                               (change)="uploadDocument($event, 5)"
                                               required>
                                        <label class="custom-file-label"
                                               for="supplier-offer">{{ fileName[5] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['5'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['5']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Si richiede un’offerta non timbrata per poter dimostrare in caso di controlli
                                        che l'impresa non ha avviato l’investimento prima della presentazione della
                                        "Domanda Nuova Sabatini".
                                    </div>
                                </div>
                            </div>
                            <div class="row m-b-10">
                                <div class="col-3 m-t-12">Contratto di Consulenza
                                    da firmare olograficamente o digitalmente
                                </div>
                                <div class="col-7 input-group mb-3">
                                    <div *ngIf="documentList['6'].length === 0" class="custom-file m-t-20 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="privacy-warrant-attorney"
                                               name="privacy-warrant-attorney"
                                               (change)="uploadDocument($event, 6)"
                                               required>
                                        <label class="custom-file-label"
                                               for="privacy-warrant-attorney">{{ fileName[6] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['6'].length > 0" class="width-100p m-t-30">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['6']">
                                                <span *ngIf="documentDetail.Path.length <= 38"
                                                      class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path | slice:0:38 }}
                                                </span>
                                                <span *ngIf="documentDetail.Path.length > 38"
                                                      class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path | slice:0:38 }}...
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Si consiglia di caricare il contratto firmato digitalmente in P7M dal legale
                                        rappresentante dell'impresa.
                                    </div>
                                </div>
                                <div class="col-2 float-right" style="padding-top: 28px; padding-right: 0;">
                                    <button type="button"
                                            (click)="downloadDocumentsToSign()"
                                            class="btn btn-embossed btn-success btn-sm">
                                        <i class="fa fa-download" style="margin-right: 10px;"></i>Download
                                    </button>
                                </div>
                            </div>
                            <div class="row m-b-10">
                                <div class="col-3 m-t-12">Distinta di Pagamento</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['7'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="payment-slip"
                                               name="payment-slip"
                                               (change)="uploadDocument($event, 7)"
                                               required>
                                        <label class="custom-file-label"
                                               for="payment-slip">{{ fileName[7] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['7'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['7']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Cliccare sulla i (qui accanto) per le istruzioni sul bonifico da effettuare
                                    </div>
                                </div>
                            </div>

                            <form role="form" class="form-horizontal form-validation">
                                <div class="text-center m-t-40">
                                    <button type="button"
                                            class="btn btn-embossed btn-info"
                                            (click)="goToStep(1)">
                                        <i class="glyphicon glyphicon-arrow-left"></i>Dati Società / Ditta
                                    </button>
                                    <button type="button"
                                            class="btn btn-embossed btn-info"
                                            (click)="goToStep(2)">
                                        <i class="glyphicon glyphicon-arrow-left"></i>Dati Investimento
                                    </button>
                                    <button type="button"
                                            class="btn btn-embossed btn-primary"
                                            (click)="saveAndGoToDashboard()">
                                        <i class="fa fa-floppy-o"></i>Salva
                                    </button>
                                    <button type="button"
                                            class="btn btn-embossed btn-success"
                                            (click)="completeRequest()"
                                            [disabled]="checkCompleteRequest()">
                                        <i class="fa fa-check"></i>Completa
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div *ngIf="request.IDRequest === undefined" class="session-invalid">
                    Impossibile recuperare la pratica
                </div>
            </div>
        </div>
    </div>
</div>
